import React, { useEffect, useState } from "react";
import { action, API, controller } from "../../../../../api/api";
import { Chip, Collapse } from "@mui/material";
import { no_img } from "../../../../../assets";
import { Input } from "../../../../../controls";

const CustomerDetails = ({ values, setValues, errors, handleInpChg }) => {
  const [customer, setCustomer] = useState({});
  useEffect(() => {
    values.customerId
      ? API(controller.Customer + action.GetById).getById(
          values.customerId,
          (res) => {
            var _cstmr = res.result;
            if (res && res.status === 200 && _cstmr) {
              setCustomer({ ..._cstmr });
              setValues((j) => ({
                ...j,
                phone: _cstmr.phone,
                email: _cstmr.email,
              }));
            } else setCustomer({});
          }
        )
      : setCustomer({});
    return () => {
      setCustomer({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.customerId]);

  return (
    <>
      <Collapse in={customer.id ? true : false}>
        <div className="pb-[10px] pt-[5px] grid gap-6">
          <div className="flex gap-4 border p-[8px] rounded-[15px]">
            <div>
              <img
                alt={customer.firstName + " " + customer.lastName}
                src={customer.photo || no_img}
                className="w-[60px] h-[60px] object-cover rounded-[10px]"
              />
            </div>
            <div className="flex items-center">
              <div className="flex flex-col text-gray-500">
                <div className="flex gap-2 items-center">
                  <span className="text-[20px]">
                    {customer.firstName + " " + customer.lastName}
                  </span>
                  {customer.cstmrGroup && (
                    <Chip
                      label={customer.cstmrGroup.name}
                      size="small"
                      className="font-bold !text-slate-500"
                    />
                  )}
                </div>
                <span className="text-[14px]">
                  {customer.cstmrCode} | {customer.phone}
                </span>
              </div>
            </div>
          </div>
          <div className="flex gap-3">
            <Input
              label="Phone"
              name="phone"
              value={values.phone}
              error={errors.phone}
              required={true}
              inputProps={{ maxLength: 150 }}
              onChange={handleInpChg}
            />
            <Input
              label="Email"
              name="email"
              value={values.email}
              error={errors.email}
              inputProps={{ maxLength: 150 }}
              onChange={handleInpChg}
            />
          </div>
          <div>
            <Input
              label="Quote Note"
              name="note"
              value={values.note}
              multiline
              rows={3}
              inputProps={{ maxLength: 500 }}
              onChange={handleInpChg}
            />
            <span className="text-[12px] text-gray-500 pl-[10px]">
              Customers will be able to see this note on their quote.
            </span>
          </div>
        </div>
      </Collapse>
    </>
  );
};

export default CustomerDetails;
